import { Text } from "@chakra-ui/react";

interface IProps {
  value: number;
  dataTest?: string;
}

const Price: React.FC<IProps> = ({ value, dataTest }) => {
  const zero = 0;
  const amount = value
    ? value.toLocaleString("cs-CZ", {
        // maximumFractionDigits: options.decimalPlaces,
        currency: "czk",
      })
    : zero.toLocaleString("cs-CZ", {
        // maximumFractionDigits: options.decimalPlaces,
        currency: "czk",
      });

  return (
    <Text as="span" data-test={dataTest} fontSize="inherit">
      {amount}&nbsp;Kč
    </Text>
  );
};

export default Price;
